import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CompanyId } from 'api/models';
import { Company, CompaniesStore } from './store';

export const slice = createSlice({
  name: '@@COMPANIES',
  initialState: CompaniesStore.empty(),

  reducers: (create) => ({
    load: create.reducer((state: CompaniesStore) =>
      CompaniesStore.load()(state),
    ),

    putAll: create.reducer(
      (_: CompaniesStore, { payload: companies }: PayloadAction<Company[]>) =>
        CompaniesStore.putAll(companies)(),
    ),

    added: create.reducer(
      (state: CompaniesStore, { payload: company }: PayloadAction<Company>) =>
        CompaniesStore.added(company)(state),
    ),

    updated: create.reducer(
      (state: CompaniesStore, { payload: company }: PayloadAction<Company>) =>
        CompaniesStore.updated(company)(state),
    ),

    removed: create.reducer(
      (
        state: CompaniesStore,
        { payload: companyId }: PayloadAction<CompanyId>,
      ) => CompaniesStore.removed(companyId)(state),
    ),
  }),
});
